/**
 * LECTURE D'UNE RÉPLIQUE MP3 — face WEB : pas de système de fichiers, un `<audio>` sur une URL
 * `data:` suffit. Même extension `.ts` que la face native (cf. `lecteurVoix.ts`).
 */

export interface Lecture {
  arreter: () => void;
}

/** Rien à régler sur le web : pas de session audio partagée avec un micro. */
export async function preparerLecture(): Promise<void> {}

export async function jouerBase64(base64: string, auDemarrage?: () => void): Promise<Lecture> {
  const audio = new Audio(`data:audio/mpeg;base64,${base64}`);
  audio.volume = 1;
  audio.addEventListener('playing', () => auDemarrage?.(), { once: true });
  await audio.play();
  return { arreter: () => audio.pause() };
}
